<template>
<div>
    <el-dialog :visible.sync="pdfPreviewDialog" title="帮助文档" :append-to-body="true" @close="closeDialog"  width="50%" center>
        <pdf :src="src"  v-for="i in pageCount" :key="i" :page="i"></pdf>
    </el-dialog>
</div>
</template>

<script>
const pdfUrl = require("../../../../static/pdfWord.pdf")
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js"
import pdf from 'vue-pdf'
export default {
    name: "pdfDialog",
    components: {pdf },
    data() {
        return {
            src: "",
            pageCount: undefined,
            currentPage: 1,
            fileType: 'pdf',
            pdfPreviewDialog: false,
        };
    },
    mounted() {
        this.src = pdfUrl
        this.openDialog(pdfUrl);
    },
    methods:{
        openDialog(){
            this.src = pdf.createLoadingTask({url:this.src,CMapReaderFactory})
            this.src.promise.then(pdf => {
                this.pageCount = pdf.numPages;
            }).catch(err => {
                console.error('pdf加载失败', err);
            })
        },
        closeDialog(){
            console.log("222222")
            // this.pageCount = undefined

        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/osNav/components/pdfDialog.vue